import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const data = {
  initialOrder: {
    destination: "",
    type: "REC",
  },
  headerOptions: [],
  steps: [
    {
      id: "0",
      name: i18n.t("reading"),
    },
    {
      id: "1",
      name: capitalize(i18n.t("association")),
    },
    {
      id: "2",
      name: i18n.t("confirmation"),
    },
  ],
};

export default data;
